<button matIconButton aria-label="search button" (click)="search()">
  <mat-icon fontSet="material-symbols-outlined">search</mat-icon>
</button>
